<script setup lang="ts">
import type { ProductSetWithImage } from '~/types/api'

const props = defineProps<{
  lineTitle?: string
  sets: ProductSetWithImage[]
  footerDescription?: string
  fabricDescription?: string
}>()

const gridSets = computed(() => {
  return transformSets(props.sets)
})

const isDescriptionsOpen = ref(false)
</script>

<template>
  <UiSection id="products" gray :title="$t('productline.productsGrid.title')">
    <ProductsGrid :sets="gridSets" subtitle-as-title />
    <div
      v-if="props.footerDescription || props.fabricDescription"
      class="mt-10"
    >
      <button
        class="flex items-center gap-2 font-semibold underline"
        @click="isDescriptionsOpen = !isDescriptionsOpen"
      >
        <Icon
          class="duration-400 rotate-180 transition-all"
          name="famicons:chevron-up"
          size="22"
          :class="{ '!rotate-0': isDescriptionsOpen }"
        />
        {{
          isDescriptionsOpen
            ? $t('productline.notes.hide')
            : $t('productline.notes.show')
        }}
      </button>
      <div
        class="my-5 flex h-0 flex-col gap-y-10 overflow-hidden text-xs"
        :class="{ 'h-fit': isDescriptionsOpen }"
      >
        <div v-if="props.footerDescription" v-html="props.footerDescription" />
        <div v-if="props.fabricDescription" v-html="props.fabricDescription" />
      </div>
    </div>
  </UiSection>
</template>
